import { Component,Input } from '@angular/core';

@Component({
    selector: 'icon-angle-left',
    templateUrl: './angle-left.component.html',
    styleUrls: ['./angle-left.component.css'],
    standalone: false
})
export class AngleLeftComponent {
  @Input() size=24;
  @Input() color='#000';
}
